import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useBreakpoints } from '@xing-com/crate-jobs-hooks';
import { IconInfo } from '@xing-com/icons';
import { usePopOver } from '@xing-com/pop-over';

import {
  CompassLegendButton,
  Legend,
  StyledContentBanner,
  StyledPopOver,
} from './tooltip-button.styles';

const cultureCompassLegendValues = {
  top: (chunks: React.ReactNode) => (
    <>
      <strong>{chunks}</strong>
      <br />
    </>
  ),
};

export const TooltipButton: React.FC<{
  messageId: string;
  helperText: string;
}> = ({ messageId, helperText }) => {
  const { formatMessage } = useIntl();
  const [showContentBanner, setShowContentBanner] = useState(false);
  const { isMediaSmallOrTiny } = useBreakpoints();
  const popOver = usePopOver();

  const handleOnClick = (): void => {
    if (isMediaSmallOrTiny) {
      setShowContentBanner((prev) => !prev);
    } else {
      popOver.togglePopOver();
    }
  };

  return (
    <>
      <CompassLegendButton
        ref={isMediaSmallOrTiny ? popOver.triggerRef : null}
        onClick={handleOnClick}
      >
        <Legend>
          <FormattedMessage
            id={messageId}
            values={cultureCompassLegendValues}
          />
        </Legend>
        <IconInfo width={18} height={18} />
      </CompassLegendButton>

      <StyledContentBanner
        display="fixed"
        show={showContentBanner}
        showCloseButton
        handleOnClose={() => setShowContentBanner(false)}
      >
        <FormattedMessage id={helperText} />
      </StyledContentBanner>

      <StyledPopOver
        isInFlow
        onOutsideClick={popOver.handleHide}
        show={popOver.show}
        triggerRef={popOver.triggerRef}
        aria-label={formatMessage({ id: helperText })}
      >
        <span aria-hidden>
          <FormattedMessage id={helperText} />
        </span>
      </StyledPopOver>
    </>
  );
};
